import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { BoxLink } from "../UI/UI";

export const RecommendedItinerariesItem = (props) => {
  const cssClass = props.cssClass != undefined ? props.cssClass : "";
  const link = props.link != undefined ? props.link : "";
  const daysTitle = props.daysTitle != undefined ? props.daysTitle : "";
  const img = props.img != undefined ? props.img : "";
  const title = props.title != undefined ? props.title : "";
  const id = props.id != undefined ? props.id : "";
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className="ac-wrapper-recommended-itineraries"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <BoxLink
        isRecomItine={daysTitle ? true : false}
        imgClock={"WhiteTime.svg"}
        img={img}
        link={link}
        isImgLink={true}
        wrapperCss={id}
        title={title}
        imgCss={"ac-" + id}
        imgArrowBlack={"arrowbright.svg"}
        imgArrowWhite={"arrowwright.svg"}
        daysTitle={daysTitle}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/RecommendedItineraries/RecommendedItinerariesItem.js